import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Waitlist from './screens/waitlist/waitlist'
import {Footer} from './screens/landing/footer'
import {Navbar} from './screens/landing/navbar'

import ErrorBoundary from './screens/ErrorBoundary/ErrorBoundary';
import './App.css';

const Landing = React.lazy(() =>  import('./screens/landing/landing'));
const Features = React.lazy(() =>  import('./screens/landing/features'))
const FAQ = React.lazy(() =>  import('./screens/landing/faq'))

function App() {
  const Spinner = (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{ height:window.innerHeight }}
    >
      <span className="spinner-border"></span>
    </div>
  );

  return (
    <BrowserRouter>
      <ErrorBoundary>
        <div className="common_header">
          <Navbar/>
          <Routes>
            <Route
              path="/"
              element={
                <Suspense fallback={Spinner}>
                  <Landing/>
                </Suspense>
              }
            />
            <Route
              path="/features"
              element={
                <Suspense fallback={Spinner}>
                  <Features/>
                </Suspense>
              }
            />
            <Route
              path="/faqs"
              element={
                <Suspense fallback={Spinner}>
                  <FAQ/>
                </Suspense>
              }
            />
            {["/participate-in-online-fitness-challenges","/waitlist"].map((path,index) => (
              <Route
              key={path}
              path={path}
              element={<Waitlist/>}
            />
            ))}
            <Route path='*' element={
              <div className="main common_header w-100"><h3 className="text-center mt-3">Sorry, page not found</h3></div>}>
          </Route>
          </Routes>
          <Footer/>
        </div>
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default App;
